import { render, staticRenderFns } from "./Sales.vue?vue&type=template&id=f05477a0&scoped=true"
import script from "./Sales.js?vue&type=script&lang=js&external"
export * from "./Sales.js?vue&type=script&lang=js&external"
import style0 from "./Sales.scss?vue&type=style&index=0&id=f05477a0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05477a0",
  null
  
)

export default component.exports